import { _ } from "extensions/underscore";
import moment from "moment";

import { Presenter } from "common/components/table/cells/generic";

// eslint-disable-next-line sentence-case/sentence-case
const DEFAULT_FORMAT = "ddd MMM D, YYYY";

export class DateTimePresenter extends Presenter {
    itemContent = (column, content) => {
        if (!content) {
            return _.propValue(column, "cellOptions.noDateMessage") || "-";
        }
        
        const displayLocal = _.propValue(column, "cellOptions.displayLocal") || false; // Should we display the date in user's local time? Assume no, by default
        const isUTC = _.propValue(column, "cellOptions.utc") === void 0; // Is date in UTC? Assume yes, by default
        const format = _.propValue(column, "cellOptions.format") || DEFAULT_FORMAT;
        const skipDateConversion = _.propValue(column, "cellOptions.skipDateConversion") || _.constant(false);
        
        if (skipDateConversion(content)) {
            return content;
        }
        
        let date;
        
        if (isUTC) {
            date = moment.utc(content);
        } else {
            date = moment(content);
        }

        if (displayLocal) {
            date = moment(date.toDate());
        }
        
        if (typeof format === "function") {
            return format(date);
        }
        
        return date.format(format);
    };
}
